import { render, staticRenderFns } from "./Login_Sinao.vue?vue&type=template&id=58773d14"
import script from "./Login_Sinao.vue?vue&type=script&lang=js"
export * from "./Login_Sinao.vue?vue&type=script&lang=js"
import style0 from "./Login_Sinao.vue?vue&type=style&index=0&id=58773d14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports